(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("tty"), require("util"), (function webpackLoadOptionalExternalModule() { try { return require("supports-color"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["tty", "util"], function webpackLoadOptionalExternalModuleAmd(__WEBPACK_EXTERNAL_MODULE_186__, __WEBPACK_EXTERNAL_MODULE_187__) {
			return factory(__WEBPACK_EXTERNAL_MODULE_186__, __WEBPACK_EXTERNAL_MODULE_187__, root["supports-color"]);
		});
	else if(typeof exports === 'object')
		exports["libR"] = factory(require("tty"), require("util"), (function webpackLoadOptionalExternalModule() { try { return require("supports-color"); } catch(e) {} }()));
	else
		root["libR"] = factory(root["tty"], root["util"], root["supports-color"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_186__, __WEBPACK_EXTERNAL_MODULE_187__, __WEBPACK_EXTERNAL_MODULE_185__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition